export default {
  en_US: {
    upgradeTitle: 'Upgrade to New Wallet',
    upgradeDescription: 'We\'ve upgraded to a fully decentralized wallet. Migrate your assets now to take full control.',
    zeroNetworkFees: 'Zero network fees',
    transferAllAssets: 'Transfer All',
    holdings: 'Holdings',
    balance: 'Balance',
    confirmTitle: 'Confirm Transfer',
    confirmDescriptionStart: 'You are about to migrate ',
    confirmDescriptionEnd: ' to your new Memeshot wallet. This action cannot be undone.',
    from: 'From',
    memeshotWallet: 'Memeshot Wallet (Legacy)',
    networkFee: 'Network Fee',
    free: 'Free',
    cancel: 'Cancel',
    confirm: 'Confirm',
    sending: 'Transferring...',
    sendingDescriptionStart: 'Migrating assets to your ',
    sendingDescriptionHighlight: 'Memeshot',
    sendingDescriptionEnd: ' new wallet',
    transferComplete: 'Transfer Complete',
    transferCompleteDescriptionStart: 'Your assets have been successfully migrated to your ',
    transferCompleteDescriptionHighlight: 'new Memeshot wallet',
    transferCompleteDescriptionEnd: '.',
    done: 'Done',
    errorLoginExpired: 'Current login expired, please click retry',
  },
  zh_CN: {
    upgradeTitle: '升级至新钱包',
    upgradeDescription: '我们已升级为完全去中心化钱包，立即迁移资产，掌握完全控制权。',
    zeroNetworkFees: '零手续费',
    transferAllAssets: '全部转出',
    holdings: '持仓',
    balance: '余额',
    confirmTitle: '确认转出',
    confirmDescriptionStart: '您即将把 ',
    confirmDescriptionEnd: ' 迁移至新的 Memeshot 钱包，此操作不可撤销。',
    from: '从',
    memeshotWallet: 'Memeshot 钱包（旧版）',
    networkFee: '网络费用',
    free: '零手续费',
    cancel: '取消',
    confirm: '确认',
    sending: '转出中...',
    sendingDescriptionStart: '正在将资产迁移至您的新 ',
    sendingDescriptionHighlight: 'Memeshot',
    sendingDescriptionEnd: ' 钱包',
    transferComplete: '转出完成',
    transferCompleteDescriptionStart: '您的资产已成功迁移至新的 ',
    transferCompleteDescriptionHighlight: 'Memeshot 钱包',
    transferCompleteDescriptionEnd: '。',
    done: '完成'
  },
  ar_SA: {
    upgradeTitle: 'الترقية إلى المحفظة الجديدة',
    upgradeDescription: 'قمنا بالترقية إلى محفظة لامركزية بالكامل. انقل أصولك الآن وتحكّم بها كلياً.',
    zeroNetworkFees: 'بدون رسوم',
    transferAllAssets: 'نقل الكل',
    holdings: 'الأصول',
    balance: 'الرصيد',
    confirmTitle: 'تأكيد نقل الأصول',
    confirmDescriptionStart: ' أنت على وشك نقل',
    confirmDescriptionEnd: ' إلى محفظتك الجديدة في Memeshot. هذا الإجراء لا يمكن التراجع عنه.',
    from: 'من',
    memeshotWallet: 'محفظة Memeshot (السابقة)',
    networkFee: 'رسوم الشبكة',
    free: 'بدون رسوم',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    sending: ' جارٍ النقل...',
    sendingDescriptionStart: ' يتم نقل أصولك إلى  محفظتك الجديدة في ',
    sendingDescriptionHighlight: 'Memeshot',
    sendingDescriptionEnd: ' ',
    transferComplete: 'تم النقل بنجاح',
    transferCompleteDescriptionStart: ' تم نقل أصولك بنجاح إلى محفظتك الجديدة في',
    transferCompleteDescriptionHighlight: 'Memeshot',
    transferCompleteDescriptionEnd: '.',
    done: 'تم'
  },
  tr_TR: {
    upgradeTitle: 'Yeni Cüzdana Yükselt',
    upgradeDescription: 'Tamamen merkeziyetsiz bir cüzdana yükseltme yaptık. Tam kontrol için varlıklarınızı şimdi aktarın.',
    zeroNetworkFees: 'Sıfır ağ ücreti',
    transferAllAssets: 'Tümünü Aktar',
    holdings: 'Varlıklar',
    balance: 'Bakiye',
    confirmTitle: 'Aktarımı Onayla',
    confirmDescriptionStart: '',
    confirmDescriptionEnd: ' tutarını yeni Memeshot cüzdanınıza aktarmak üzeresiniz. Bu işlem geri alınamaz.',
    from: 'Gönderen',
    memeshotWallet: 'Memeshot Cüzdan (Eski)',
    networkFee: 'Ağ Ücreti',
    free: 'Ücretsiz',
    cancel: 'İptal',
    confirm: 'Onayla',
    sending: 'Aktarılıyor...',
    sendingDescriptionStart: 'Varlıklarınız yeni ',
    sendingDescriptionHighlight: 'Memeshot',
    sendingDescriptionEnd: ' cüzdanınıza aktarılıyor',
    transferComplete: 'Aktarım Tamamlandı',
    transferCompleteDescriptionStart: 'Varlıklarınız yeni ',
    transferCompleteDescriptionHighlight: 'Memeshot cüzdanınıza',
    transferCompleteDescriptionEnd: ' başarıyla aktarıldı.',
    done: 'Tamam',
    errorLoginExpired: 'Mevcut oturum süresi doldu, lütfen yeniden deneyin'
  },
  ko_KR: {
    upgradeTitle: '새 지갑으로 업그레이드',
    upgradeDescription: '완전한 탈중앙화 지갑으로 업그레이드되었습니다. 지금 자산을 이전하여 완벽하게 관리하세요.',
    zeroNetworkFees: '네트워크 수수료 무료',
    transferAllAssets: '전체 이전',
    holdings: '보유 자산',
    balance: '잔액',
    confirmTitle: '이전 확인',
    confirmDescriptionStart: '',
    confirmDescriptionEnd: '을(를) 새 Memeshot 지갑으로 이전합니다. 이 작업은 취소할 수 없습니다.',
    from: '보내는 곳',
    memeshotWallet: 'Memeshot 지갑 (기존)',
    networkFee: '네트워크 수수료',
    free: '무료',
    cancel: '취소',
    confirm: '확인',
    sending: '이전 중...',
    sendingDescriptionStart: '새 ',
    sendingDescriptionHighlight: 'Memeshot',
    sendingDescriptionEnd: ' 지갑으로 자산을 이전하고 있습니다',
    transferComplete: '이전 완료',
    transferCompleteDescriptionStart: '자산이 새 ',
    transferCompleteDescriptionHighlight: 'Memeshot 지갑',
    transferCompleteDescriptionEnd: '으로 성공적으로 이전되었습니다.',
    done: '완료'
  }
}